import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { LocationScheduleComponent } from '../../shared/location-schedule/location-schedule.component';
import { LocationContactInfoComponent } from './location-contact-info/location-contact-info.component';

@Component({
  selector: 'app-request-appointment',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './request-appointment.component.html',
  imports: [NzDividerModule, LocationContactInfoComponent, LocationScheduleComponent],
  standalone: true,
})
export class RequestAppointmentComponent {}
